import { createSyntheticEvent } from "shared/utils/EventUtils";

export interface FormSubmitEventDetails {
  skipOnSuccess?: boolean;
}

export class FormSubmitEvent extends window["CustomEvent"]<
  FormSubmitEventDetails | undefined
> {
  constructor(detail: FormSubmitEventDetails) {
    super("formSubmit", { detail });
  }
}

export const createFormSubmitEvent = (detail: FormSubmitEventDetails) =>
  createSyntheticEvent(new FormSubmitEvent(detail));

export type FormSubmitEventType = ReturnType<typeof createFormSubmitEvent>;
